import script from "./PasswordPop.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordPop.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordPop.vue?vue&type=style&index=0&id=57870fdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57870fdf"]])

export default __exports__